import AuthCurrentTenant from 'src/modules/auth/authCurrentTenant';

const STORAGE_KEY = 'auth.userDisabled';

export const USER_DISABLED_REASON = 'USER_DISABLED';

export function isCurrentTenantDisabled(currentUser) {
  const memberships = currentUser?.tenants || [];
  const currentTenantId = AuthCurrentTenant.get();

  if (currentTenantId) {
    return memberships.some(
      (membership) =>
        String(membership?.tenant?.id) ===
          String(currentTenantId) &&
        membership.status === 'disabled',
    );
  }

  const activeMemberships = memberships.filter(
    (membership) => membership.status === 'active',
  );

  return (
    activeMemberships.length === 0 &&
    memberships.some(
      (membership) => membership.status === 'disabled',
    )
  );
}

export function rememberDisabledReason() {
  sessionStorage.setItem(STORAGE_KEY, 'true');
}

export function hasDisabledReason() {
  return sessionStorage.getItem(STORAGE_KEY) === 'true';
}

export function consumeDisabledReason() {
  const wasDisabled = hasDisabledReason();
  sessionStorage.removeItem(STORAGE_KEY);
  return wasDisabled;
}

export function hasDisabledReasonInSearch(search) {
  return (
    new URLSearchParams(search).get('socialErrorCode') ===
    USER_DISABLED_REASON
  );
}

export function selectErrorReason(error) {
  return error?.response?.data?.error?.reason || null;
}
